export function BooleanDisplay({ cell: { value } }: { cell: { value: any } }) {
  if (value) return 'Yes';
  else return 'No';
}
export function DateDisplay({ cell: { value } }: { cell: { value: any } }) {
  if (value === null) return '-';
  else return new Date(value).toDateString();
}
